import React from 'react';
import WaitingViewer from 'components/WaitingViewer';
import { ReactComponent as TreeMap } from 'assets/icons/tree-map.svg';

export const EmptyState: React.FC<Props | any> = ({
  waitTime,
  haveResponses
}) => {
  return (
    <div className="empty-state">
      {haveResponses ? (
        <>
          <div className="empty-state-icon">
            <TreeMap />
          </div>
          <div className="empty-state-title">There is no response selected</div>
          <div className="empty-state-description">
            Select a company from the list to view their responses, plans and
            contacts
          </div>
        </>
      ) : (
        <WaitingViewer waittime={waitTime} title="The response is not ready" />
      )}
    </div>
  );
};

type ownProps = {
  waitTime: any;
  haveResponses: boolean;
};

type Props = ownProps;

EmptyState.displayName = 'EmptyState';

export default React.memo(EmptyState);
